// CartConvert clones product buttons and intercepts their click handlers.
// Route product clicks through the form's existing validated AJAX submission.
// Capture runs before the app's handler on the cloned button.
document.addEventListener('click', function (event) {
  var button = event.target.closest && event.target.closest('[data-submit-button]');
  if (!button || button.disabled || !button.form ||
      !button.form.matches('form[data-product-form]') ||
      typeof button.form.requestSubmit !== 'function') return;

  event.preventDefault();
  event.stopImmediatePropagation();
  button.form.requestSubmit(button);
}, true);
